import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import 'assets/styles/global.css'
import OptionsContextProvider from 'utils/Context/OptionsContext'
import { MainFrame } from './UI/components/MainFrame'
import HouseScan from './UI/pages/HouseScan'
import StepperContextProvider from './utils/Context/StepperContext'
import SharedDataContextProvider from './utils/Context/SharedDataContext'
import LanguageContextProvider from './utils/Context/LanguageContext'

const App = (props: { contractDisabled: boolean, leadsource: number, directFlow?: string }) => {
  
  return (
    <div className='app'>
      <Router>
        <Switch>
          <Route path='/'>
            <OptionsContextProvider {...props}>
              <StepperContextProvider>
                <MainFrame>
                  <SharedDataContextProvider>
                    <LanguageContextProvider>
                      <HouseScan />
                    </LanguageContextProvider>
                  </SharedDataContextProvider>
                </MainFrame>
              </StepperContextProvider>
            </OptionsContextProvider>
          </Route>
        </Switch>
      </Router>
    </div>
  )
}

export { App }

